import { render, staticRenderFns } from "./PosCard.vue?vue&type=template&id=6526ef9a&"
import script from "./PosCard.vue?vue&type=script&lang=js&"
export * from "./PosCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports